import React from "react";
import Radio from "antd/lib/radio";
import {
  SurveyNoticeCard,
  SurveyQuestionCard,
  SymptomAlertCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface DizzynessSectionProps {
  readonly currentPage: number;
}

export const DizzynessSection: React.FC<DizzynessSectionProps> = ({
  currentPage
}) => {
  return (
    <>
      {currentPage === 1 && (
        <>
          <SurveyNoticeCard />
          <SurveyQuestionCard
            sectionTag="DIZZYNESS"
            title="Have you been feeling dizzy or lightheaded during dialysis recently?"
            required
          >
            <FormItemStyle
              name="Have you been feeling dizzy"
              label=""
              rules={[{ required: true }]}
              initialValue={""}
            >
              <Radio.Group
                value={localStorage.getItem("feelingDizzyRecently")}
                onChange={e => {
                  localStorage.setItem("feelingDizzyRecently", e.target.value);
                }}
              >
                <AnswerList>
                  <AnswerOption value="NO">NO</AnswerOption>
                  <AnswerOption value="Rarely (1 - 2 / Month)">
                    Rarely (1 - 2 / Month)
                  </AnswerOption>
                  <AnswerOption value="Occasional (3 - 4 / Month)">
                    Occasional (3 - 4 / Month)
                  </AnswerOption>
                  <AnswerOption value="Frequent (5 - 10 / Month)">
                    Frequent (5 - 10 / Month)
                  </AnswerOption>
                  <AnswerOption value="Every dialysis (11 - 13 / Month)">
                    Every dialysis (11 - 13 / Month)
                  </AnswerOption>
                </AnswerList>
              </Radio.Group>
            </FormItemStyle>
          </SurveyQuestionCard>
        </>
      )}
      {currentPage === 2 && (
        <SymptomAlertCard message="Please discuss your symptoms of dizzyness with your nurse or doctor" />
      )}
    </>
  );
};
